import React, { useEffect, useRef } from 'react';

import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';

import { AutomationMessageTypeIcon } from '../ui/automation-message-type-icon';
import { StyledTimelineItem } from '../ui/styled-timeline';

import { AutomationCard } from './automation-card';

import { AutomationsByTriggerDictionary } from '../../utils/applicant-automation-display-utils';
import { isApplicantAutomation } from '../../utils/is-applicant-automation';

export const AutomationTimelineItem = ({
  automation,
  org,
  editingForJob,
  section,
  followUpsForSection,
  isViewing,
  toggleIsViewing,
  parentAutomationsForSection,
  focusApplicantAutomation,
}: {
  automation: StartDateTriggeredCommunication | ApplicantAutomation;
  org: Org;
  editingForJob?: Job;
  section?: ApplicantAutomationSection;
  followUpsForSection?: ApplicantAutomation[];
  isViewing: boolean;
  toggleIsViewing: () => void;
  parentAutomationsForSection?: AutomationsByTriggerDictionary;
  focusApplicantAutomation?: ApplicantAutomation | null;
}) => {
  const automationRef = useRef<HTMLDivElement | null>(null);

  const defaultExpanded =
    isApplicantAutomation(automation) &&
    automation.applicantTriggeredCommunicationId ===
      focusApplicantAutomation?.applicantTriggeredCommunicationId;

  useEffect(() => {
    if (automationRef?.current) {
      automationRef.current.scrollIntoView({ block: 'center' });
    }
  });

  return (
    <StyledTimelineItem ref={defaultExpanded ? automationRef : null}>
      <TimelineSeparator>
        <TimelineConnector />
        <TimelineDot>
          <AutomationMessageTypeIcon automation={automation} />
        </TimelineDot>
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent>
        <AutomationCard
          automation={automation}
          org={org}
          editingForJob={editingForJob}
          section={section}
          followUpsForSection={followUpsForSection}
          isViewing={isViewing}
          toggleIsViewing={toggleIsViewing}
          parentAutomationsForSection={parentAutomationsForSection}
        />
      </TimelineContent>
    </StyledTimelineItem>
  );
};
